export default __webpack_public_path__ + "static/media/51t.df807da6.jpg";